import { REGIONS_WITHOUT_WE_SKI } from '@/ots-constants';

export const isRegionWithoutWeSki = (regionId: string, locale: string) => (
  REGIONS_WITHOUT_WE_SKI.some((region) => region.locale === locale && region.regionId === regionId)
);
